/**
 * 本地兜底气泡：后端 /chat/suggestions 没上线 / 调用失败时使用。
 * 各应用的具体条目由 `setAiRuntime({ localSuggestions })` 注入，
 * 后端就绪后可整体移除（_chatSuggestions 接管）。
 */
import { peekAiRuntime } from '../runtime';
import type { ModuleSuggestionsVO } from '../services/aiAssistant';

export const COMMON_CAPABILITIES = ['解读结果', '决策建议', '异常诊断', '生成报告'];

export const DEFAULT_SUGGESTIONS: ModuleSuggestionsVO = {
  capabilities: COMMON_CAPABILITIES,
  suggestions: [
    { icon: '💬', text: '这个页面能做什么？' },
    { icon: '📊', text: '帮我看看当前数据' },
    { icon: '✍️', text: '帮我生成一份总结' }
  ]
};

export function getLocalSuggestions(moduleId?: string): ModuleSuggestionsVO {
  const map = peekAiRuntime()?.localSuggestions ?? {};
  if (moduleId && map[moduleId]) return map[moduleId];
  return map.default ?? DEFAULT_SUGGESTIONS;
}
